import React from 'react';
import {Inputs, Typography} from 'components';

import {makeStyles} from '@material-ui/styles';

const useStyles = makeStyles((theme) => ({
    wrapper: {
        border: `solid 1px ${theme.palette.blue}`,
        marginBottom: theme.spacing(3)
    },
    header: {
        background: theme.palette.blue,
        display: 'flex',
        alignItems: 'center',
        minHeight: 45,
        padding: theme.spacing(0, 2)
    },
    content: {
        margin: 'auto',
        maxWidth: 700,
        padding: theme.spacing(2)
    }
}));

function StepDocuments() {
    const classes = useStyles();

    return (
        <>
            <div className={classes.wrapper}>
                <div className={classes.header}>
                    <Typography
                        variant="h4"
                        color="white"
                        caps
                        semibold
                        gutterBottom={false}
                    >
                        4. Pièces justificatives
                    </Typography>
                </div>

                <div className={classes.content}>
                    <Typography color="blue">
                        ■&nbsp;&nbsp;Carte Nationale d'Identité ou passeport en cours de validité
                    </Typography>
                    <Inputs.File
                        name="passport"
                        accept={['pdf']}
                    />
                    <Typography color="blue">■&nbsp;&nbsp;Dernière situation de compte</Typography>
                    <Inputs.File
                        name="last_account_situation"
                        accept={['pdf']}
                    />
                    <Typography color="blue">
                        ■&nbsp;&nbsp;Justificatif de la rupture du contrat de travail (si nécessaire)<sup>(1)</sup>
                    </Typography>
                    <Inputs.File
                        name="termination_employment_contract"
                        accept={['pdf']}
                    />
                    <Typography color="blue">
                        En cas de besoin, vous pouvez contacter le Service Client : 09 70 80 80 57
                    </Typography>
                </div>
            </div>
            <Typography color="blue">
                (1) Solde de tout compte, certificat de travail, lettre de licenciement...
            </Typography>
        </>
    );
}

export default StepDocuments;
